module.exports = __webpack_public_path__ + "images/avatars/female/8.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/8.svg
// module id = 9+MG
// module chunks = 51